import React from 'react';
import { Container, Accordion, Row, Col } from 'react-bootstrap';
import { FaBullhorn, FaMoneyBillWave, FaUsers, FaLock, FaExclamationTriangle } from 'react-icons/fa';
import {
  PageContainer,
  PageHeader,
  InfoCard,
  AccordionScenario,
  AnimatedSection,
  accordionStyles
} from '../../../components/SharedComponents';

const scenarios = [
  {
    id: 1,
    icon: <FaBullhorn />,
    title: 'W odpowiedzi na argument "Mamy pilny termin / Dużo zamówień"',
    color: '#667eea',
    argument: 'Musisz przyjść w tę sobotę, bo inaczej nie zdążymy/nie wyrobimy się z zamówieniami. Liczę na Twoją pomoc.',
    response: 'Rozumiem, że firma ma dużo pracy i pilne terminy, ale niestety nie mogę przyjść w sobotę. Jako pracownik młodociany, prawo gwarantuje mi 48 godzin nieprzerwanego odpoczynku, w tym całą niedzielę, zgodnie z Art. 203 § 3 Kodeksu pracy. Złamanie tego przepisu jest niemożliwe. Chętnie wykonam więcej pracy w dni robocze, ale weekend jest zarezerwowany na odpoczynek.'
  },
  {
    id: 2,
    icon: <FaMoneyBillWave />,
    title: 'W odpowiedzi na argument "To będzie dobrze płatne / Dostaniesz premię"',
    color: '#f093fb',
    argument: 'Zostań w sobotę, dam Ci super premię/dostaniesz podwójną stawkę za ten dzień. Warto dla pieniędzy!',
    response: 'Dziękuję za propozycję, ale muszę odmówić. Chociaż premia jest kusząca, przepisy dotyczące pracownika młodocianego są bezwzględnie obowiązujące i nie można ich zmienić, nawet za dodatkową opłatą czy moją zgodą. Art. 203 § 3 KP chroni mój obowiązkowy odpoczynek tygodniowy. Muszę go wykorzystać, by mieć siłę do nauki i pracy w nadchodzącym tygodniu.'
  },
  {
    id: 3,
    icon: <FaUsers />,
    title: 'W odpowiedzi na argument "Wszyscy dorośli przychodzą/Pomóż kolegom"',
    color: '#4facfe',
    argument: 'Starsi pracownicy dają radę. Musisz być bardziej zaangażowany/a i pomóc zespołowi. Wszyscy przychodzimy w soboty.',
    response: 'Rozumiem potrzebę wsparcia zespołu, ale mój status jako pracownika młodocianego oznacza, że nie podlegam tym samym zasadom co dorośli pracownicy. Moje prawa do odpoczynku są regulowane osobnym przepisem – Art. 203 § 3 Kodeksu pracy, który wprost nakłada na firmę obowiązek zapewnienia mi co najmniej 48 godzin wolnego, zawsze obejmującego niedzielę. Nie mogę pracować wbrew temu prawu.'
  },
  {
    id: 4,
    icon: <FaLock />,
    title: 'W odpowiedzi na formalne polecenie (np. wywieszone na grafiku)',
    color: '#43e97b',
    argument: '(Wskazuje na grafik lub polecenie służbowe) Masz wpisane w grafik. Widzisz, że masz być w pracy.',
    response: 'Uprzejmie informuję, że zapis w grafiku, który narusza moje 48 godzin nieprzerwanego odpoczynku tygodniowego, wliczając w to niedzielę, jest nieważny z punktu widzenia prawa pracy. Polecenie pracy w sobotę, które narusza Art. 203 § 3 KP, jest niezgodne z prawem. Nie jestem zobowiązany/a go wykonać. Proszę o skorygowanie mojego harmonogramu pracy.'
  },
  {
    id: 5,
    icon: <FaExclamationTriangle />,
    title: 'Przy stanowczym nacisku i groźbie konsekwencji',
    color: '#f5576c',
    argument: 'Jeśli nie przyjdziesz, to cię zwolnię, a nieobecność ta będzie traktowana jako nieobecność nieusprawiedliwiona.',
    response: 'Moja nieobecność w sobotę będzie usprawiedliwiona ustawowym prawem do odpoczynku, które gwarantuje mi Art. 203 § 3 Kodeksu pracy. Próba ukarania mnie lub zwolnienia za przestrzeganie prawa, które ma mnie chronić, może zostać potraktowana jako wykroczenie przeciwko prawom pracownika młodocianego i zostanie zgłoszone do odpowiednich organów (np. Państwowej Inspekcji Pracy).'
  }
];

const SaturdayWork = () => {
  return (
    <PageContainer>
      <Container>
        <style>{accordionStyles}</style>
        
        <PageHeader 
          title="Praca w sobotę"
          subtitle="Szablony rozmów dotyczących pracy w weekendy"
        />

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <AnimatedSection>
              <InfoCard>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                  Jako pracownik młodociany masz bezwzględne prawo do 48 godzin nieprzerwanego odpoczynku tygodniowego, 
                  w tym całej niedzieli (Art. 203 § 3 Kodeksu pracy). Poniżej znajdziesz gotowe szablony odpowiedzi 
                  na różne argumenty pracodawcy.
                </p>
              </InfoCard>
            </AnimatedSection>

            <Accordion alwaysOpen>
              {scenarios.map((scenario, index) => (
                <AccordionScenario
                  key={scenario.id}
                  scenario={scenario}
                  index={index}
                  eventKey={String(index)}
                  argumentLabel="Argumentacja pracodawcy"
                  responseLabel="Asertywna odpowiedź"
                />
              ))}
            </Accordion>

            <AnimatedSection delay={0.6} className="mt-4">
              <InfoCard
                gradient="rgba(255, 0, 0, 0.1)"
                borderColor="rgba(255, 0, 0, 0.3)"
                icon={<FaExclamationTriangle style={{ color: '#ff0000' }} />}
                title="Pamiętaj"
              >
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                  Pamiętaj, że w przypadku naruszenia Art. 203 § 3 KP, to pracodawca popełnia wykroczenie. 
                  Nie można Cię ukarać za odmowę wykonania polecenia, które jest niezgodne z Kodeksem pracy.
                </p>
              </InfoCard>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
};

export default SaturdayWork;